<template>
    <div class="article-renderer">
        <div class="article-renderer-header">
            <div class="article-go-back"  @click="goBack">
                <img :src="goBackIcon" alt="Back button"/>
                <h2>Back</h2>
            </div>
            <div class="open-article-new-tab" @click="redirectToNewTab" >
                <img :src="redirectToNewTabIcon" alt="Redirect to new tab"/>
                <div class="open-article-new-tab-tool-tip">Open in new tab</div>
            </div>
        </div>
        <div class="article-content-container ck-content" id="ck">
            <h1 class="article-title-render" v-html="parseHtml(article.title)" />
            <div v-html="parseHtml(article.content)" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import DOMPurify from 'dompurify';
import goBackIcon from '../assets/images/go-back.svg';
import redirectToNewTabIcon from '../assets/images/redirect-to-new-tab.svg';
import { sendGainSightEvent, SURFACE_KB_IN_CHAT_GS_EVENTS } from '../../gainSightIntegration';

export default {
    name: 'ArticleRenderer',
    data() {
      return {
        goBackIcon,
        redirectToNewTabIcon
      }
    },
    props: {
        id: Number,
        article: Object
    },
    computed: {
        ...mapGetters({
            kbDetails: 'kbDetails/getKbDetails'
        }),
        redirectUrl() {
            return `${this.kbDetails.origin}/${this.article.categoryTitle.toLowerCase().replace(/\s+/g, '-')}/${this.article.slug}`;
        }
    },
    methods: {
        redirectToNewTab() {
            const articleOpenData = {
                articleTitle: this.article.title,
                articleUrl: this.redirectUrl,
            };
            sendGainSightEvent(SURFACE_KB_IN_CHAT_GS_EVENTS.WIDGET_ARTICLE_OPEN, articleOpenData);
            window.open(this.redirectUrl, '_blank');
        },
        goBack() {
            this.$router.go(-1);
        },
        getVideoId(url) {
            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
            const match = url.match(regExp);
            if (match && match[2].length == 11) {
                return match[2];
            } else {
                return false;
            }
        },
        parseHtml(html) {
            let tmp = document.createElement("div");
            tmp.innerHTML = html.replace(/<\/?mark>/g, '');
            let anchorTags = tmp.querySelectorAll("a");
            anchorTags.forEach((anchor) => {
                anchor.setAttribute('target', '_blank');
                anchor.setAttribute('rel', 'noopener noreferrer');
            });
            let figureArray = tmp.querySelectorAll("figure");
            figureArray.forEach((figure) => {
                let oembed = figure?.querySelector("oembed");
                figure.style.width = "auto";
                figure.style.height = "auto";
                if (oembed) {
                    let url = oembed?.getAttribute("url");
                    let videoId = this.getVideoId(url);
                    let iframe = document.createElement("iframe");
                    if (videoId) {
                        iframe?.setAttribute("src", `//www.youtube.com/embed/${videoId}`);
                    }
                    figure.replaceChildren(iframe);
                }
            });
            return DOMPurify.sanitize(tmp.innerHTML, {
                ADD_TAGS: ["oembed", "iframe"],
                ADD_ATTR: ["url", "src", "target"],
            });
        }
    }
}
</script>
<style scoped>
@import "~widget/assets/scss/ckEditor.scss";
@import "~widget/assets/scss/_articlesInChat.scss";
</style>
